// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"b817d0c9","570":"2ef81caf","631":"b817d0c9","945":"b817d0c9"}[chunkId] + ".chunk.css";
};